<template>
  <div>
    <div class="offerCard" @click="triggerOfferDetailsModal()">
      <div :style="getOfferComponentTopStyle">
        <div v-if="!dataIsOfferApplied && !dataFromCart">
          <div class="offerCardTop">
            <div class="">
              <div class="d-flex">
                <p
                  class="couponSavingMessage"
                  :class="[
                    dataIsApplicable ? 'color-white' : 'color-slaty-dark',
                  ]"
                >
                  {{ dataDisplayMessage }}
                </p>
              </div>
            </div>
            <div class="d-flex pl12">
              <span
                v-if="dataPromoCode"
                :class="dataIsApplicable ? 'couponCode' : 'disableCouponCode'"
                >{{ dataPromoCode }}</span
              >
              <!-- <div v-if="showTooltip" class="coupon-tooltip-card">Copied!</div> -->
            </div>
          </div>
          <div class="d-flex justify-content-between align-items-center pt10">
            <span
              class="offercardtext"
              :class="[dataIsApplicable ? 'color-white' : 'color-slaty-dark']"
              >{{ dataText }}</span
            >
            <i
              class="hkfi-arrow-line rotate90 showMoreDetails"
              @click="triggerOfferDetailsModal()"
            ></i>
          </div>
        </div>
        <div v-else>
          <div
            v-if="
              (dataFromCart && dataErrorMsg) ||
              (!dataIsApplicable && dataIsOfferApplied)
            "
            class="color-error fs-14 fw-800"
          >
            Sorry, "{{ dataPromoCode }}" not Applied
          </div>
          <div class="color-white bold fs-14" v-else>
            {{ dataDisplayMessage }}
          </div>
          <div
            class="d-flex justify-content-between align-items-center color-white fs-12 pt12"
          >
            <div class="d-flex align-items-center">
              <div
                v-if="
                  (dataFromCart && dataErrorMsg) ||
                  (!dataIsApplicable && dataIsOfferApplied)
                "
                class="color-error fs-12"
              >
                {{ dataErrorMsg }}
              </div>
              <div v-else>
                <i class="hkfi-tick-icon fs-16"></i> {{ dataPromoCode }} applied
              </div>
            </div>
            <div
              class="underline-dotted pt5 fw-600"
              :class="{
                'remove-invalid-items':
                  (dataFromCart && dataErrorMsg) ||
                  (!dataIsApplicable && dataIsOfferApplied),
              }"
              @click="triggerOfferSelected"
            >
              Remove
            </div>
          </div>
        </div>
      </div>
      <div :style="getOfferComponentBottomStyle">
        <div
          class="d-flex align-items-center justify-content-center fs-12 pt8"
          v-if="dataFromCart"
          @click="handleViewAllOffers"
        >
          View all offers <i class="hkfi-arrow-line pl5 fs-10"></i>
        </div>
        <div v-else>
          <div class="offerCardBottom" v-if="!dataIsOfferApplied">
            <div class="flex-row">
              <img
                :src="dataOfferIcon"
                alt="dataoffericon"
                v-if="dataExpiryTimer?.endTime || dataBottomMsg"
              />
              <div class="pl5 color-slaty" v-if="dataExpiryTimer?.endTime">
                <div>Coupon expires in</div>
                <div class="bold">{{ expiryTime }}</div>
              </div>
              <div
                class="pl5 color-slaty d-flex align-items-center tl"
                v-else-if="dataBottomMsg"
              >
                {{ dataBottomMsg }}
              </div>
            </div>
            <button
              v-if="!isDesktop && dataIsApplicable"
              class="enabledbutton bold ml10 btn"
              @click="triggerOfferSelected"
            >
              {{ dataAction }}
            </button>
            <button
              v-else-if="!dataIsApplicable"
              class="enabledbutton bold ml10 btn p2"
              @click="goToMenu"
            >
              Add Item
            </button>
          </div>
          <div class="d-flex justify-content-between align-items-center" v-else>
            <span
              class="offercardtext ellips-L2"
              :class="[dataIsApplicable ? '' : 'color-slaty-dark']"
              >{{ dataText }}</span
            >
            <i
              class="hkfi-arrow-line rotate90 showMoreDetailsSelected"
              @click="triggerOfferDetailsModal()"
            ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LocalStorageFunc from "../helpers/localStorageFunc";
import { keyMapsAction, keyMapsMutation } from "../helpers/storeKeys";
import { staticImgBaseUrl } from "../config/apiEndpoints";
import Utility from "../helpers/utility";
import { clientPlatform } from "../config/apiEndpoints";
import {
  EVENT_IMPRESSION_OFFERS,
  EVENT_CLICK_VIEWMORE_OFFER_CARD,
  EVENT_CLICK_OFFER_SELECT,
  EVENT_CLICK_ADD_MORE_ITEMS,
  EVENT_OFFER_SCREEN,
  EVENT_OFFER_CARD,
} from "../helpers/analyticsEvents";

export default {
  name: "OfferListingCard",
  props: [
    "dataIndex",
    "dataTitle",
    "dataPromoCode",
    "dataDisplayMessage",
    "dataText",
    "dataOfferList",
    "dataAction",
    "dataOfferType",
    "dataItemTnc",
    "dataSelectedOffer",
    "dataSectionPosition",
    "dataIsApplicable",
    "dataBottomMsg",
    "dataOfferIcon",
    "dataOfferBackgroundTop",
    "dataOfferBackgroundBottom",
    "dataExpiryTimer",
    "dataTheme",
    "dataFromCart",
    "dataErrorMsg",
    "dataIsImplicit",
    "dataIsOfferApplied",
    "dataHeading",
  ],
  data() {
    return {
      staticImgBaseUrl,
      clientPlatform,
      showTooltip: false,
      expiryTime: "",
    };
  },
  mounted() {
    EVENT_IMPRESSION_OFFERS({
      sectionName: this.dataTitle,
      sectionPosition: this.dataIndex + 1,
      positionWithinSection: "",
    });
    if (this.dataExpiryTimer?.endTime - Date.now() > 0) {
      this.startInterval();
    }
  },
  beforeDestroy() {
    this.clearInterval();
  },
  methods: {
    expiryTimer() {
      if (this.dataExpiryTimer?.endTime - Date.now() > 0) {
        this.expiryTime = Utility.formatTimestampOffer(
          this.dataExpiryTimer?.endTime - Date.now(),
        );
      }
    },
    startInterval() {
      this.intervalId = setInterval(() => {
        this.expiryTimer();
      }, 1000);
    },
    clearInterval() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    },
    goToMenu() {
      EVENT_OFFER_CARD({
        eventAction: "add item",
        sectionName: this.dataHeading,
      });
      EVENT_CLICK_ADD_MORE_ITEMS();
      Utility.sendToMenuScreen();
    },
    async copyCouponCode(couponCode) {
      try {
        await navigator.clipboard.writeText(couponCode);
        this.showTooltip = true;
        setTimeout(() => {
          this.showTooltip = false;
        }, 2000);
      } catch (err) {
        console.error("Unable to copy text to clipboard", err);
      }
    },
    handleViewAllOffers(e) {
      e.stopPropagation();
      Utility.sendToOffersScreen();
    },
    triggerOfferDetailsModal() {
      if (this.dataItemTnc) {
        EVENT_CLICK_VIEWMORE_OFFER_CARD({
          couponCode: this.dataPromoCode,
          sectionPosition: this.dataSectionPosition,
          positionWithinSection: this.dataIndex + 1,
        });
        EVENT_OFFER_CARD({
          eventAction: "card_click",
          sectionName: this.dataHeading,
        });
        document.body.classList.add("body-stop-scroll-mobile");

        if (!this.isDesktop) {
          this.$store.commit(
            keyMapsMutation.UPDATE_OFFER_DETAILS_MODAL_FLAG,
            true,
          );
        }

        this.$store.dispatch(keyMapsAction.OFFER_TNC_API, {
          campaignId: this.dataItemTnc,
        });

        this.$store.commit(
          keyMapsMutation.UPDATE_SELECTED_OFFER,
          this.offersList.find((i) => i.couponCode == this.dataPromoCode),
        );
      }
    },
    triggerOfferSelected(e) {
      e.stopPropagation();
      EVENT_OFFER_CARD({
        eventAction: "apply",
        sectionName: this.dataHeading,
      });
      if (
        this.$store.state.Offers.appliedOfferPromo != this.dataPromoCode &&
        !this.dataIsImplicit
      ) {
        this.$store.commit(
          keyMapsMutation.UPDATE_SELECTED_OFFER_THEME,
          this.dataTheme,
        );
        if (this.isCartSelected) {
          this.$store.dispatch(keyMapsAction.APPLY_OFFER_API, {
            couponCode: this.dataPromoCode,
            source: this.dataHeading,
            detail: this.dataDisplayMessage,
          });
          this.$store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_MODAL, true);
          setTimeout(this.closeAppliedModal, 3000);
        } else {
          this.$store.commit(
            keyMapsMutation.UPDATE_APPLIED_COUPON_PROMO,
            this.dataPromoCode,
          );
          this.$store.commit(
            keyMapsMutation.UPDATE_OFFER_DETAILS_MODAL_FLAG,
            false,
          );
          this.$store.commit(
            keyMapsMutation.UPDATE_SELECTED_OFFER_INDEX,
            this.dataIndex,
          );
          EVENT_CLICK_OFFER_SELECT({
            subCategory: "selected",
            sectionPosition: this.dataSectionPosition,
            positionWithinSection: this.dataIndex + 1,
            category: this.dataPromoCode,
          });
          const cartReponse = LocalStorageFunc.getCartResponse();
          EVENT_OFFER_SCREEN({
            eventAction: "offer applied",
            sectionName: this.dataHeading,
            category: "offer application",
            subcategory: "offer application success",
            cartId: LocalStorageFunc.cartId(),
            couponDetail: this.dataDisplayMessage,
            paymentMethod: "",
            discount: cartReponse?.calculations?.find(
              (res) => res.key == "discount",
            )?.value,
            subTotal: cartReponse?.calculations?.find(
              (res) => res.key == "sub_total",
            )?.value,
            itemTotal:
              cartReponse?.calculations?.find((res) => res.key == "sub_total")
                ?.value -
              cartReponse?.calculations?.find((res) => res.key == "discount")
                ?.value +
              cartReponse?.calculations?.find(
                (res) => res.key == "tax_and_charges",
              )?.value,
            coupon: this.dataPromoCode,
            deliveryCharge: cartReponse?.calculations?.find(
              (res) => res.key == "tax_and_charges",
            )?.value,
            paymentMethodSaved: "No",
          });
          LocalStorageFunc.updateCouponCode(this.dataPromoCode);
          this.$store.commit(keyMapsMutation.UPDATE_IS_HAMBURGER, false);
          this.$store.commit(keyMapsMutation.UPDATE_VIEW_ALL_OFFERS, false);
          if (window.location.href?.includes("/store")) {
            this.$store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_MODAL, true);
            setTimeout(this.closeAppliedModal, 3000);
          } else {
            LocalStorageFunc.setOfferAppliedModal(true);
            Utility.redirectToHomeOrRedirectUrl();
          }
        }
      } else {
        this.$store.commit(keyMapsMutation.UPDATE_SELECTED_OFFER_THEME, "");
        this.$store.commit(keyMapsMutation.UPDATE_APPLIED_COUPON_PROMO, "");
        if (this.isCartSelected) {
          if (this.dataIsImplicit) {
            LocalStorageFunc.setDisableAutoApplyImplicitPromo(true);
          }
          this.$store.dispatch(keyMapsAction.CREATE_CART_ITEMS_API);
        } else {
          EVENT_CLICK_OFFER_SELECT({
            subCategory: "unselected",
            sectionPosition: this.dataSectionPosition,
            positionWithinSection: this.dataIndex + 1,
            category: this.dataPromoCode,
          });
          LocalStorageFunc.updateCouponCode("");
          this.$store.commit(keyMapsMutation.UPDATE_IS_HAMBURGER, false);
        }
      }
    },
    closeAppliedModal(event) {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.$store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_MODAL, false);
    },

    closeofferSelectedModal() {
      this.$store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_MODAL, false);
    },
  },
  computed: {
    isDesktop() {
      return Utility.isDesktop();
    },
    getOfferComponentTopStyle() {
      return {
        background: `url(${this.dataOfferBackgroundTop})`,
        backgroundRepeat: `no-repeat`,
        backgroundSize: `100% auto`,
        padding: "12px 16px",
      };
    },
    getOfferComponentBottomStyle() {
      return {
        background: `url(${this.dataOfferBackgroundBottom})`,
        backgroundRepeat: `no-repeat`,
        backgroundSize: `100% auto`,
        padding: "10px",
        minHeight: this.clientPlatform == "Web" ? "75px" : "62px",
      };
    },
    paymentSelectedOfferIndex() {
      return this.$store.state.PaymentOffers.paymentSelectedOfferIndex;
    },
    selectedPaymentOfferTnc() {
      return this.$store.state.PaymentOffers.selectedPaymentOfferTnc;
    },
    isCartSelected() {
      return LocalStorageFunc.getPrevUrl().includes("/cart");
    },
    offersList() {
      return this.$store.state.Offers.offersList;
    },
  },
};
</script>
<style></style>
